module.exports = __webpack_public_path__ + "967fa0a85c949207bca1b8eb963731a3.mp4";